import { render, staticRenderFns } from "./AlertRuleDeploymentsView.vue?vue&type=template&id=976d255e&scoped=true&lang=pug&"
import script from "./AlertRuleDeploymentsView.vue?vue&type=script&lang=ts&"
export * from "./AlertRuleDeploymentsView.vue?vue&type=script&lang=ts&"
import style0 from "./AlertRuleDeploymentsView.vue?vue&type=style&index=0&id=976d255e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976d255e",
  null
  
)

export default component.exports